var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 54,
    viewBox: "0 0 72 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.8201 16.3682L36.121 0L10.6066 11.5633H8.55326H7.95485H6.69937V24.8339C5.71962 25.1917 5.02734 26.0952 5.02734 27.1571C5.02734 28.1016 5.57882 28.923 6.38843 29.3454L5.02734 32.1086H10.2311L8.87006 29.3454C9.67967 28.923 10.2311 28.1016 10.2311 27.1571C10.2311 26.0952 9.533 25.1917 8.55913 24.8339V20.469L16.0333 23.8072V32.7364C29.6031 22.5341 42.8854 23.0973 55.9799 32.7364V23.6371L71.8201 16.3682Z",
    fill: "url(#paint0_linear_379_1776)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9238 48.8225L35.9399 53.774L40.9383 48.8401C37.9111 46.5286 34.0743 46.511 30.9238 48.8225Z",
    fill: "url(#paint1_linear_379_1776)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.51474 13.8809L0 16.3684L5.51474 18.8558V13.8809Z",
    fill: "url(#paint2_linear_379_1776)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5625 36.667L21.7305 39.7763C25.5146 36.1038 30.6128 34.0035 36.0043 34.0035C41.3372 34.0035 46.4119 36.0568 50.1842 39.6649L53.3112 36.5379C48.6882 32.1144 42.5398 29.6738 36.0043 29.6738C29.3925 29.6797 23.1972 32.1613 18.5625 36.667Z",
    fill: "url(#paint3_linear_379_1776)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8105 42.8156L27.6852 45.6434C30.0613 43.8423 33.2059 42.5868 35.9867 42.5868C38.7616 42.5868 41.783 43.8423 44.159 45.6434L47.1217 42.7042C44.03 40.3634 39.671 38.7617 35.9867 38.7617C32.2965 38.7559 27.9082 40.469 24.8105 42.8156Z",
    fill: "url(#paint4_linear_379_1776)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_379_1776",
    x1: 38.8867,
    y1: 7.45937,
    x2: 38.2146,
    y2: 28.073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#339CE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5BDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_379_1776",
    x1: 37.2827,
    y1: 7.39803,
    x2: 36.611,
    y2: 27.9955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#339CE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5BDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_379_1776",
    x1: 3.12533,
    y1: 6.33002,
    x2: 2.45371,
    y2: 26.9263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#339CE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5BDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_379_1776",
    x1: 36.8887,
    y1: 7.34217,
    x2: 36.2158,
    y2: 27.9798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#339CE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5BDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_379_1776",
    x1: 37.1229,
    y1: 7.34186,
    x2: 36.4501,
    y2: 27.9733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#339CE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5BDF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1);
export default __webpack_public_path__ + "static/media/logo1.eace63daba27ef08f7a8c9b48ed61db4.svg";
export { ForwardRef as ReactComponent };